<h2 mat-dialog-title>Speaker exists</h2>
<mat-dialog-content>The speaker you are trying to add already exists.</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" mat-button mat-dialog-close>Okay</button>
</mat-dialog-actions>
